export default "__VITE_ASSET__BSLduQCk__"